<script>import { cn } from "../../utils/twClnm.js";
export let primary = true;
export let size = "medium";
export let isDelete = false;
export let normal = false;
export let isModelButton = false;
export let modelButton = false;
export let onclick = () => {
};
</script>

<button
	type="button"
	on:click={onclick}
	{...$$restProps}
	class={cn(
		{
			'tw-flex tw-h-9 tw-w-44 tw-cursor-pointer tw-items-center tw-justify-center tw-gap-2 tw-rounded-full tw-font-default tw-font-medium tw-leading-none': true,
			'px-5 tw-text-sm': size === 'medium',
			'px-4 tw-text-xs': size === 'small',
			'tw-border-transparent tw-bg-blue-600 tw-stroke-white tw-text-white': primary,
			'tw-border-indigo-60 tw-border tw-border-blue-600 tw-bg-transparent tw-text-gray-800': !primary,
			'tw-border-indigo-60 tw-border tw-border-red-600 tw-bg-transparent tw-text-red-500':isDelete,
			'tw-border-indigo-60 tw-border  tw-bg-white tw-text-gray-800': normal,
			'tw-border-blue-500 tw-text-blue-500 ':modelButton && isModelButton,
			'tw-border tw-border-solid tw-border-border tw-text-[#171717]':!modelButton && isModelButton
		},
		$$restProps.class
	)}
>
	<slot />
</button>
